import React, { Component } from 'react';
import { Link } from 'react-router-dom';
export default class TermsAndCondition extends Component {
    constructor(props) {
        super(props)
        this.state = {
            sellerFooterData: []
        };
    }
    render() {
        let sessionSiteDetails = window.sessionStorage.getItem('siteDetails');
        var siteDetails = JSON.parse(sessionSiteDetails);
        //console.log('siteDetails....))))).......', siteDetails)
        // if (siteDetails.siteData[0].sellerData.length > 0) {
        //     this.setState({
        //         sellerFooterData: siteDetails.siteData[0].sellerData[0].sellerFooterData
        //     });
        // }
        let themeId = localStorage.getItem('themeId')
        return (
            (() => {
                if (themeId === '34'|| themeId === '29'|| themeId === '4') {
                    return (
                        siteDetails.siteData[0].siteCategoryData.length > 0 ?
                            siteDetails.siteData[0].siteCategoryData[0].siteFooterData.map((data,index) => (
                                <div key={index}>
                                    {(() => {
                                        if (data.url == '' & data.content != null && data.name == 'Terms & Conditions') {
                                            return (
                                                <Link to={{ pathname: "/footerContent/" + data.id, state: { footerData: data } }} ><span>Terms of Service</span></Link>
                                            )
                                        }
                                    })()}
                                </div>
                            ))
                        : ''
                    )
                }
                else {
                    return (
                        siteDetails.siteData[0].sellerData.length > 0 ?
                            siteDetails.siteData[0].sellerData[0].sellerFooterData.map((data,index) => (
                                <div key={index}>
                                    {(() => {
                                        if (data.url == '' & data.content != null && data.name == 'Terms & Conditions') {
                                            return (
                                                <Link to={{ pathname: "/footerContent/" + data.id, state: { footerData: data } }} ><span>Terms of Service</span></Link>
                                            )
                                        }
                                    })()}
                                </div>
                            ))
                        : ''
                    )
                }
            })()
        )
    }
}